module.exports = __webpack_public_path__ + "static/media/serviceCenterImg02.4c1e98e8.png";